import { Link } from 'react-router-dom';

export default function SoyProteinTimingPage() {
  return (
    <div className="min-h-screen bg-white text-[#5D4037]">
      {/* Header */}
      <header className="bg-white border-b border-[#E0D7D0] sticky top-0 z-50">
        <div className="container mx-auto px-6 py-4">
          <span className="font-bold text-xl text-[#bc6355]">プロテイン選びの教科書</span>
        </div>
      </header>

      {/* Breadcrumb */}
      <nav className="bg-[#FAF9F8] border-b border-[#E0D7D0]">
        <div className="container mx-auto px-6 py-3">
          <ul className="flex items-center gap-2 text-sm">
            <li>
              <a
                href="https://soyproteinranking.com/"
                className="flex items-center gap-2 text-[#8D6E63] hover:text-[#bc6355] transition-colors whitespace-nowrap"
              >
                <span className="w-4 h-4 flex items-center justify-center text-[#bc6355]">
                  <i className="ri-home-4-line"></i>
                </span>
                <span>トップ</span>
              </a>
            </li>
            <li className="text-[#BCAAA4]">/</li>
            <li className="text-[#5D4037] whitespace-nowrap">
              ソイプロテインの効果的な飲むタイミング
            </li>
          </ul>
        </div>
      </nav>

      {/* Main Content */}
      <main className="container mx-auto px-6 py-12 max-w-4xl">
        {/* Hero Section */}
        <section className="mb-12">
          <h1 className="text-3xl font-bold text-white mb-6 bg-gradient-to-r from-[#bc6355] to-[#d4847a] px-6 py-4 rounded-lg leading-tight">
            ソイプロテインの飲むタイミングは？目的別の効果的な飲み方
          </h1>

          <p className="text-[#5D4037] leading-relaxed mb-4">
            「せっかくソイプロテインを飲むなら、一番効果が出る時間に飲みたい」と思いませんか？
          </p>

          <p className="text-[#5D4037] leading-relaxed">
            ソイプロテインはホエイに比べて吸収がゆっくりという特徴があるため、
            <span className="text-[#bc6355] font-semibold underline decoration-[#F9EBEA] decoration-4">
              「いつ飲むか」によって得られるメリットが大きく変わります。
            </span>
            ダイエットや美容、健康維持など、あなたの目的に合わせたベストタイミングを解説します。
          </p>
        </section>

        {/* Feature Section (Three Best Timings) */}
        <section className="mb-12">
          <h2 className="text-2xl font-bold text-[#5D4037] mb-6 pb-3 border-b-4 border-[#bc6355]">
            おすすめの基本タイミング3選
          </h2>

          <p className="text-[#5D4037] leading-relaxed mb-6">
            ソイプロテインの最大の特徴である「腹持ちの良さ」を最大限に引き出すタイミングは以下の3つです。
          </p>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8">
            <div className="p-4 bg-[#FDF8F3] rounded-lg border border-[#E8DDD4]">
              <h4 className="font-bold text-[#bc6355] mb-2">朝食と一緒に</h4>
              <p className="text-sm">
                体内の栄養が枯渇している朝に補給。日中の活動に向けた代謝アップと満足感維持に。
              </p>
            </div>
            <div className="p-4 bg-[#FDF8F3] rounded-lg border border-[#E8DDD4]">
              <h4 className="font-bold text-[#bc6355] mb-2">間食の代わりに</h4>
              <p className="text-sm">
                小腹が空く午後に。ゆっくり吸収されるため、夕食までのドカ食いを防ぐことができます。
              </p>
            </div>
            <div className="p-4 bg-[#FDF8F3] rounded-lg border border-[#E8DDD4]">
              <h4 className="font-bold text-[#bc6355] mb-2">寝る30分〜1分前</h4>
              <p className="text-sm">
                睡眠中の成長ホルモンに合わせて補給。就寝中の筋肉維持や美容ケアをサポートします。
              </p>
            </div>
          </div>
        </section>

        {/* Comparison Table (By Goal) */}
        <section className="mb-12">
          <h3 className="text-xl font-bold text-[#5D4037] mb-6">
            【目的別】ベストな飲み合わせとタイミング
          </h3>

          <div className="overflow-hidden rounded-lg border border-[#E0D7D0] shadow-sm mb-8 bg-white">
            <table className="w-full text-center">
              <thead>
                <tr className="bg-[#FAF9F8]">
                  <th className="px-6 py-4 text-sm font-semibold text-[#5D4037] border-b border-[#E0D7D0]">
                    目的
                  </th>
                  <th className="px-6 py-4 text-sm font-semibold text-[#bc6355] border-b border-[#E0D7D0]">
                    タイミング
                  </th>
                  <th className="px-6 py-4 text-sm font-semibold text-[#5D4037] border-b border-[#E0D7D0]">
                    期待できる効果
                  </th>
                </tr>
              </thead>
              <tbody className="divide-y divide-[#E0D7D0]">
                <tr>
                  <td className="px-6 py-4 bg-[#FAF9F8] font-semibold text-sm">ダイエット</td>
                  <td className="px-6 py-4 text-[#5D4037] text-sm">食前 または 置き換え</td>
                  <td className="px-6 py-4 text-[#5D4037] text-sm">総摂取カロリーの抑制</td>
                </tr>
                <tr>
                  <td className="px-6 py-4 bg-[#FAF9F8] font-semibold text-sm">筋力キープ</td>
                  <td className="px-6 py-4 text-[#5D4037] text-sm">運動の30分〜1時間前</td>
                  <td className="px-6 py-4 text-[#5D4037] text-sm">運動中の筋肉分解を防ぐ</td>
                </tr>
                <tr>
                  <td className="px-6 py-4 bg-[#FAF9F8] font-semibold text-sm">美容・習慣</td>
                  <td className="px-6 py-4 text-[#bc6355] font-semibold text-sm">
                    就寝前
                  </td>
                  <td className="px-6 py-4 text-[#5D4037] text-sm">肌や髪の栄養補給</td>
                </tr>
              </tbody>
            </table>
          </div>
        </section>

        {/* Pros & Cons Section (Notice about Exercise) */}
        <section className="mb-12">
          <h2 className="text-2xl font-bold text-[#5D4037] mb-6 pb-3 border-b-4 border-[#bc6355]">
            タイミング別の注意点
          </h2>

          <div className="mb-8">
            <h4 className="text-lg font-bold text-[#5D4037] mb-4 border-l-4 border-[#bc6355] pl-3">
              運動直後よりも「運動前」がおすすめ
            </h4>
            <p className="text-[#5D4037] leading-relaxed">
              ソイプロテインは吸収が遅いため、運動直後の「ゴールデンタイム」に飲むとリカバリーに時間がかかります。<strong>運動の1時間ほど前</strong>に飲んでおくことで、トレーニング中に血中アミノ酸濃度を高く保つことができ、効率的に体を守れます。
            </p>
          </div>

          <div className="mb-8">
            <h4 className="text-lg font-bold text-[#5D4037] mb-4 border-l-4 border-[#BCAAA4] pl-3">
              寝る直前は「消化器官」に配慮を
            </h4>
            <p className="text-[#5D4037] leading-relaxed">
              寝る直前に飲むと胃腸に負担がかかる場合があります。<strong>就寝の30分〜1時間前</strong>までには飲み終えるのが理想です。また、夜は冷たい水ではなく、常温やぬるま湯で割ることで体を冷やさずに済みます。
            </p>
          </div>
        </section>

        {/* Recommended Schedule Section */}
        <section className="mb-12">
          <h2 className="text-2xl font-bold text-[#5D4037] mb-6 pb-3 border-b-4 border-[#bc6355]">
            理想的な1日のスケジュール例
          </h2>

          <div className="bg-gradient-to-br from-[#FAF9F8] to-[#F3EFEF] rounded-xl p-8 border border-[#E0D7D0] shadow-sm">
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <div className="flex-shrink-0 w-6 h-6 rounded-full bg-[#bc6355] text-white flex items-center justify-center text-sm font-semibold mt-0.5">
                  7:00
                </div>
                <p className="text-[#5D4037]">
                  <strong>朝食と一緒に：</strong>パンやサラダにプラスして、バランスの良い1日のスタート。
                </p>
              </li>
              <li className="flex items-start gap-3">
                <div className="flex-shrink-0 w-6 h-6 rounded-full bg-[#bc6355] text-white flex items-center justify-center text-sm font-semibold mt-0.5">
                  15:00
                </div>
                <p className="text-[#5D4037]">
                  <strong>おやつタイムに：</strong>甘いお菓子の代わりに。満足感が高いので夕食の食べ過ぎ防止に。
                </p>
              </li>
              <li className="flex items-start gap-3">
                <div className="flex-shrink-0 w-6 h-6 rounded-full bg-[#bc6355] text-white flex items-center justify-center text-sm font-semibold mt-0.5">
                  22:00
                </div>
                <p className="text-[#5D4037]">
                  <strong>リラックスタイムに：</strong>1日の終わりの美容ケアとして。ホットソイにすると安眠効果も。
                </p>
              </li>
            </ul>
          </div>
        </section>

        {/* Summary Section */}
        <section className="mb-12">
          <h2 className="text-2xl font-bold text-[#5D4037] mb-6 pb-3 border-b-4 border-[#bc6355]">
            まとめ
          </h2>

          <div className="bg-[#bc6355] text-white rounded-xl p-8 shadow-sm">
            <div className="space-y-4 leading-relaxed">
              <p>
                ソイプロテインは、その「ゆっくり吸収される性質」を理解することで、より賢く生活に取り入れることができます。
              </p>
              <p>
                まずは<strong>「朝食時」か「間食」</strong>のどちらか、取り入れやすいタイミングから始めてみてください。時間が安定してくると、体の変化もより実感しやすくなるはずです。
              </p>
              <p className="pt-4 text-center font-bold border-t border-[#d4847a]">
                あなたのライフスタイルに最適なタイミングを見つけて、効率よく理想の自分へ近づきましょう。
              </p>
            </div>
          </div>
        </section>
      </main>
    </div>
  );
}